import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import skills from "../images/Skills.png";
import { IoNavigate } from "react-icons/io5";
function SkillsHome() {
  const navto = useNavigate();
  const skillspage = () => {
    navto("/skills");
  };
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end
  return (
    <>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      >
        <div className="inner-sec">
          <h2 className="sec-head">Skills</h2>
          <p className="sec-para">
            I'm a front-end developer with 1+ year experience. I am familiar with HTML, CSS, JavaScript,
            Bootstrap, Wordpress, ReactJS, NodeJS as well as a variety of tools
            such as Adobe Photoshop, Illustrator, XD, and Figma.
            {/* I'm a front-end developer. I am familiar with Adobe
            Photoshop, Illustrator, XD, and Figma, as well as a variety of tools
            and programming languages such as HTML, CSS, JavaScript, VS Code,
            Atom, Wordpress, ReactJS, and others. */}
          </p>
          <motion.button
            className="sec-btn btn "
            initial={{ opacity: 0.6 }}
            whileHover={{
              scale: 1.1,
              transition: { duration: 1 },
            }}
            whileTap={{ scale: 0.9 }}
            whileInView={{ opacity: 1 }}
            onClick={skillspage}
          >
            Know More{" "}
            <span className="ms-2">
              <IoNavigate />
            </span>
          </motion.button>
        </div>
      </motion.div>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12 text-center"
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}
      >
        <img src={skills} alt="skills" className="sec-img-w" />
      </motion.div>
    </>
  );
}

export default SkillsHome;
